import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-sand-timer',
	templateUrl: './icon-sand-timer.component.svg',
})
export class IconSandTimerComponent {}
